import { getClipboardConfigForColumn } from './utils/clipboard-config';
import { populateFillHandleStrictCopy } from './utils/fill-handler';
export default class AbstractColumnHelper {
    constructor() {
        this.columnDefaultMeta = {};
    }
    equalityComparison(a, b, _param) {
        return a == b;
    }
    populateFillHandle(params) {
        return populateFillHandleStrictCopy(params);
    }
    getClipboardConfig(params) {
        return getClipboardConfigForColumn({ col: params.col });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sdW1uLmludGVyZmFjZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvY29sdW1uSGVscGVyL2NvbHVtbi5pbnRlcmZhY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLDJCQUEyQixFQUFFLE1BQU0sMEJBQTBCLENBQUM7QUFDdkUsT0FBTyxFQUFFLDRCQUE0QixFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFFcEUsTUFBTSxDQUFDLE9BQU8sT0FBZ0Isb0JBQW9CO0lBQWxEO1FBQ1Msc0JBQWlCLEdBQXlCLEVBQUUsQ0FBQztJQW9FdEQsQ0FBQztJQW5CUSxrQkFBa0IsQ0FDdkIsQ0FBTSxFQUNOLENBQU0sRUFDTixNQUEyQztRQUUzQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDaEIsQ0FBQztJQUVNLGtCQUFrQixDQUFDLE1BSXpCO1FBQ0MsT0FBTyw0QkFBNEIsQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUM5QyxDQUFDO0lBRU0sa0JBQWtCLENBQUMsTUFBMkM7UUFDbkUsT0FBTywyQkFBMkIsQ0FBQyxFQUFFLEdBQUcsRUFBRSxNQUFNLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQztJQUMxRCxDQUFDO0NBQ0YifQ==